/**
 * Countdown Timer Block - Frontend JavaScript
 */

(function() {
    'use strict';

    // Store for text-only Swiper instances
    if (!window.textOnlySwipers) {
        window.textOnlySwipers = {};
    }

    // Set countdown timer block height as CSS variable on HTML
    function setCountdownHeightVariable() {
        const countdownBlock = document.querySelector('.countdown-timer-block');
        if (countdownBlock) {
            const height = countdownBlock.offsetHeight;
            document.documentElement.style.setProperty('--countdown-timer-height', height + 'px');
        } else {
            document.documentElement.style.setProperty('--countdown-timer-height', '0px');
        }
    }

    // Initialize all countdown timers on the page
    function initCountdownTimers() {
        const countdownBlocks = document.querySelectorAll('.countdown-timer-block');

        // Early return if no countdown blocks exist
        if (!countdownBlocks || countdownBlocks.length === 0) {
            return;
        }

        countdownBlocks.forEach(function(block) {
            const timerId = block.id;
            const layoutMode = block.getAttribute('data-layout-mode');
            const targetDate = block.getAttribute('data-target-date');
            const showCompletedMessage = block.getAttribute('data-show-completed') === 'true';

            // Handle text-only mode with Swiper
            if (layoutMode === 'text-only') {
                initTextOnlySwiper(block);
                return;
            }

            if (!targetDate || !timerId) return;

            // Initialize the timer
            initTimer(timerId, targetDate, showCompletedMessage);
        });
    }

    // Initialize Swiper for text-only mode
    function initTextOnlySwiper(block, retryCount) {
        retryCount = retryCount || 0;
        const maxRetries = 10;
        const timerId = block.id;
        const storageKey = 'countdown_text_only_closed_' + timerId;

        // Check if already closed
        if (localStorage.getItem(storageKey) === 'true') {
            block.style.display = 'none';
            setCountdownHeightVariable();
            return;
        }

        // Check if already initialized
        if (window.textOnlySwipers && window.textOnlySwipers[timerId]) {
            return;
        }

        const swiperEl = block.querySelector('.text-only-swiper');
        if (!swiperEl) {
            return;
        }

        // Get item count with fallback - count slides if attribute missing
        var itemCountAttr = swiperEl.getAttribute('data-item-count');
        var itemCount = itemCountAttr ? parseInt(itemCountAttr, 10) : 0;

        // Fallback: count actual swiper slides if data attribute is invalid
        if (isNaN(itemCount) || itemCount === 0) {
            var slides = swiperEl.querySelectorAll('.swiper-slide');
            itemCount = slides ? slides.length : 0;
        }

        // Initialize Swiper only if there are multiple items
        if (itemCount > 1) {
            // If Swiper is not available yet, retry after a short delay
            if (typeof Swiper === 'undefined') {
                if (retryCount < maxRetries) {
                    setTimeout(function() {
                        initTextOnlySwiper(block, retryCount + 1);
                    }, 200);
                }
                return;
            }

            // Get autoplay speed from data attribute with fallback
            var autoplaySpeedAttr = swiperEl.getAttribute('data-autoplay-speed');
            var autoplaySpeed = autoplaySpeedAttr ? parseInt(autoplaySpeedAttr, 10) : 2500;
            if (isNaN(autoplaySpeed) || autoplaySpeed < 500) {
                autoplaySpeed = 2500;
            }

            window.textOnlySwipers[timerId] = new Swiper(swiperEl, {
                direction: 'vertical',
                loop: true,
                autoplay: {
                    delay: autoplaySpeed,
                    disableOnInteraction: false,
                },
            });
        }

        // Close button functionality
        const closeBtn = block.querySelector('.countdown-close');
        if (closeBtn) {
            closeBtn.addEventListener('click', function() {
                block.style.display = 'none';
                localStorage.setItem(storageKey, 'true');
                if (window.textOnlySwipers && window.textOnlySwipers[timerId]) {
                    window.textOnlySwipers[timerId].autoplay.stop();
                }
                // Update CSS variable after closing
                setCountdownHeightVariable();
            });
        }
    }

    // Initialize a single timer
    function initTimer(timerId, targetDate, showCompletedMessage) {
        const timerContainer = document.getElementById(timerId);
        if (!timerContainer) return;

        // Check if timer is already initialized
        if (window.countdownTimers && window.countdownTimers[timerId]) {
            return;
        }

        function updateTimer() {
            const now = new Date().getTime();
            const target = new Date(targetDate).getTime();
            const difference = target - now;

            const completedMessage = timerContainer.querySelector('.countdown-completed-message');
            const timerContainerEl = timerContainer.querySelector('.countdown-timer-container');

            if (difference > 0) {
                const days = Math.floor(difference / (1000 * 60 * 60 * 24));
                const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((difference % (1000 * 60)) / 1000);

                // Update numbers with animation
                const timeValues = { days, hours, minutes, seconds };
                timerContainer.querySelectorAll('.timer-number').forEach(function(el) {
                    const unit = el.getAttribute('data-unit');
                    if (unit && timeValues.hasOwnProperty(unit)) {
                        const newValue = timeValues[unit].toString().padStart(2, '0');
                        const currentValue = el.textContent;

                        if (newValue !== currentValue) {
                            // Add animation class
                            el.classList.add('updating');

                            // Update the value
                            el.textContent = newValue;

                            // Remove animation class after animation completes
                            setTimeout(function() {
                                el.classList.remove('updating');
                            }, 200);
                        }
                    }
                });

                // Hide completed message
                if (completedMessage) {
                    completedMessage.style.display = 'none';
                }
                if (timerContainerEl) {
                    timerContainerEl.style.display = 'flex';
                }

                // Remove completed class
                timerContainer.classList.remove('completed');

            } else {
                // Show completed message
                if (completedMessage && showCompletedMessage) {
                    completedMessage.style.display = 'block';
                }
                if (timerContainerEl) {
                    timerContainerEl.style.display = 'none';
                }

                // Add completed class
                timerContainer.classList.add('completed');

                // Clear timer
                if (window.countdownTimers && window.countdownTimers[timerId]) {
                    clearInterval(window.countdownTimers[timerId]);
                    delete window.countdownTimers[timerId];
                }

                // Trigger completion event
                const completionEvent = new CustomEvent('countdownCompleted', {
                    detail: {
                        timerId: timerId,
                        targetDate: targetDate
                    }
                });
                document.dispatchEvent(completionEvent);
            }
        }

        // Initialize timer storage
        if (!window.countdownTimers) {
            window.countdownTimers = {};
        }

        // Start the timer
        updateTimer();
        window.countdownTimers[timerId] = setInterval(updateTimer, 1000);

        // Add loading state initially
        timerContainer.classList.add('loading');

        // Remove loading state after first update
        setTimeout(function() {
            timerContainer.classList.remove('loading');
        }, 100);
    }

    // Pause all timers (useful for performance when page is not visible)
    function pauseTimers() {
        if (window.countdownTimers) {
            Object.keys(window.countdownTimers).forEach(function(timerId) {
                clearInterval(window.countdownTimers[timerId]);
                delete window.countdownTimers[timerId];
            });
        }
    }

    // Resume all timers
    function resumeTimers() {
        const countdownBlocks = document.querySelectorAll('.countdown-timer-block');

        if (!countdownBlocks || countdownBlocks.length === 0) {
            return;
        }

        countdownBlocks.forEach(function(block) {
            const timerId = block.id;
            const layoutMode = block.getAttribute('data-layout-mode');
            const targetDate = block.getAttribute('data-target-date');
            const showCompletedMessage = block.getAttribute('data-show-completed') === 'true';

            // Skip text-only mode (no timer to resume)
            if (layoutMode === 'text-only') {
                return;
            }

            // Check if countdownTimers exists and timer not already running
            if (targetDate && timerId && window.countdownTimers && !window.countdownTimers[timerId]) {
                initTimer(timerId, targetDate, showCompletedMessage);
            }
        });
    }

    // Handle page visibility changes for performance
    function handleVisibilityChange() {
        if (document.hidden) {
            // Page is hidden, pause timers to save resources
            pauseTimers();
        } else {
            // Page is visible, resume timers
            resumeTimers();
        }
    }

    // Handle window focus/blur for better performance
    function handleWindowFocus() {
        resumeTimers();
    }

    function handleWindowBlur() {
        // Only pause if page is also hidden
        if (document.hidden) {
            pauseTimers();
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initCountdownTimers();
            setCountdownHeightVariable();
        });
    } else {
        initCountdownTimers();
        setCountdownHeightVariable();
    }

    // Also run on window load to ensure CSS is fully applied (fixes deferred JS timing)
    window.addEventListener('load', function() {
        setCountdownHeightVariable();
    });

    // Update height variable on window resize
    window.addEventListener('resize', setCountdownHeightVariable);

    // Helper function to initialize a single block (timer or text-only)
    function initBlock(block) {
        const timerId = block.id;
        const layoutMode = block.getAttribute('data-layout-mode');
        const targetDate = block.getAttribute('data-target-date');
        const showCompletedMessage = block.getAttribute('data-show-completed') === 'true';

        if (layoutMode === 'text-only') {
            initTextOnlySwiper(block);
        } else if (targetDate && timerId) {
            initTimer(timerId, targetDate, showCompletedMessage);
        }
    }

    // Handle dynamic content loading (AJAX, etc.)
    document.addEventListener('DOMContentLoaded', function() {
        // Initialize any timers that might be added dynamically
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            if (node.classList && node.classList.contains('countdown-timer-block')) {
                                // New countdown timer added
                                setTimeout(function() {
                                    initBlock(node);
                                }, 100);
                            } else if (node.querySelectorAll) {
                                // Check for countdown timers in added content
                                const newTimers = node.querySelectorAll('.countdown-timer-block');
                                newTimers.forEach(function(timer) {
                                    setTimeout(function() {
                                        initBlock(timer);
                                    }, 100);
                                });
                            }
                        }
                    });
                }
            });
        });

        // Start observing
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    // Performance optimizations
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleWindowFocus);
    window.addEventListener('blur', handleWindowBlur);

    // Cleanup on page unload
    window.addEventListener('beforeunload', function() {
        if (window.countdownTimers) {
            Object.keys(window.countdownTimers).forEach(function(timerId) {
                clearInterval(window.countdownTimers[timerId]);
            });
            window.countdownTimers = {};
        }
    });

    // Expose functions for external use
    window.CountdownTimer = {
        init: initCountdownTimers,
        pause: pauseTimers,
        resume: resumeTimers,
        initTimer: initTimer,
        initTextOnlySwiper: initTextOnlySwiper,
        updateHeightVariable: setCountdownHeightVariable
    };

})();
